export default __webpack_public_path__ + "static/logo-horizontal-black-6664a372059530447fe899366f19a656.svg";